// NPC sprite registry - high-detail per-NPC spritesheets generated by
// tools/npc_sprite_pipeline.py. Each sheet is 384x256 (3 cols x 2 rows of
// 128x128 idle frames). Loaded by both PreloadScene (in-game) and
// EditorPhaserScene (map editor) under the keys defined here.
//
// Adding a new NPC sprite:
//   1. Drop sheet-transparent.png at sprites/npc/<id>/sheet-transparent.png
//   2. Copy it to client/public/assets/npc/<id>/sheet.png
//   3. Add the id to NPC_SPRITE_IDS below.

export const NPC_SPRITE_FRAME_W = 128;
export const NPC_SPRITE_FRAME_H = 128;

export const NPC_SPRITE_IDS: readonly string[] = [
  'ancient_hero_ghost',
  'arielle_cloud',
  'atlantis_king',
  'aziz_refugee',
  'blacksmith',
  'chaos_goblin',
  'devias_warden',
  'elaria_noria',
  'elder_lorencia',
  'elf_aiden',
  'guild_master',
  'izabel_wizard',
  'lost_soul',
  'mail_postman',
  'merchant_silvia',
  'mermaid_selpheri',
  'mysterious_wanderer',
  'neptus_master',
  'salim_caravan',
  'seraph_sky',
  'shop_jewel',
  'shop_potion',
  'shop_weapon',
  'smith_triton',
  'storage_bento',
  'tarkan_priest',
  'tracker_faylin',
  'trader_brom',
  'trainer_archer',
  'trainer_warrior',
  'trainer_wizard',
  'vergil_dungeon',
  'wanderer_liaria',
  'warp_charon',
  'warp_noria_north',
  'werewolf_kalima',
] as const;

export const NPC_SPRITE_KEY_PREFIX = 'npc_sheet_';

export function npcSpriteKey(id: string): string {
  return `${NPC_SPRITE_KEY_PREFIX}${id}`;
}

export function npcSpriteUrl(id: string): string {
  return `/assets/npc/${id}/sheet.png`;
}

export function isNpcSpriteKey(key: string | undefined | null): boolean {
  return !!key && key.startsWith(NPC_SPRITE_KEY_PREFIX);
}

export const NPC_SPRITE_ENTRIES: ReadonlyArray<{ id: string; key: string; url: string }> =
  NPC_SPRITE_IDS.map((id) => ({ id, key: npcSpriteKey(id), url: npcSpriteUrl(id) }));
